import phonitixPoster from "../assets/images/posters/Design Posters/Workshops/phonetix.jpg";
import edgePoster from "../assets/images/posters/Design Posters/Workshops/edge-ai.jpg";
import cstPoster from "../assets/images/posters/Design Posters/Workshops/cst.jpg";

export const workshops = [
  {
    title: "PHONETIX - Voice Controlled Bot",
    poster: phonitixPoster,
    shortDesc:
      "Build and control a robot using voice commands in a hands-on workshop.",
    description:
      "A hands-on workshop conducted with the Robotics Club of CEG. Participants receive a take-away kit and learn to build and control a robot using voice commands. The workshop also acts as a qualifier for the VISION’26 Bot Challenge.",
    team: "Up to 4 members",
    fee: "₹1499 per team",
    date: "18 February 2026",
    time: "9:30 AM – 4:00 PM",
    venue: "Ground Floor LH, ECE Department",
    contact: [
      { name: "Animaria A", phone: "8870794015" },
      { name: "Ishva S", phone: "9360995575" },
    ],
    link: "https://forms.gle/Xh3EsBCVMmrphmMa8",
  },
  {
    title: "Edge AI Workshop",
    poster: edgePoster,
    shortDesc:
      "Learn to run AI models directly on edge devices through a hands-on workshop.",
    description:
      "A practical Edge AI workshop organized by ECEA where participants learn how to deploy AI models directly on edge hardware instead of relying on cloud processing.",
    team: "Individual Participation",
    fee: "₹100 per participant",
    date: "25 February 2026",
    time: "9:00 AM – 4:00 PM",
    venue: "Ground Floor Lecture Hall, ECE Department",
    contact: [
      { name: "Ishva S", phone: "9360995575" },
      { name: "Keerthana", phone: "8428875054" },
    ],
    link: "https://forms.gle/BnXKGD8m6cix8UUR9",
  },
  {
  title: "Industrial Innovations with CST – Antenna Simulation Workshop",

  poster: cstPoster,

  shortDesc:
    "Learn how engineers simulate and optimize antennas and wireless systems using CST Studio Suite before building real hardware.",

  description:
    "This workshop introduces participants to CST Studio Suite and how it is used by engineers to design, test, and optimize electromagnetic and antenna systems through simulation. The session includes practical insights into real-world wireless system design and electromagnetic analysis.",

  team: "Individual Participation",

  fee: "₹50 per participant",

  date: "14 March 2026",

  time: "9:00 AM – 1:00 PM",

  venue: "Mini Auditorium, ECE Department",

  speaker: "Mr. Praveenkumar Palaniyappan",

  contact: [
    { name: "Ishva S", phone: "9360995575" },
    { name: "Shafiulla S", phone: "6374935513" }
  ],

  link: "https://forms.gle/XV9DQZiNVaeAoh41A"
}
];
